import { render } from "./task-list.vue?vue&type=template&id=1e844156&scoped=true"
import script from "./task-list.vue?vue&type=script&lang=js"
export * from "./task-list.vue?vue&type=script&lang=js"

import "./task-list.vue?vue&type=style&index=0&id=1e844156&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e844156"]])

export default __exports__